export default __webpack_public_path__ + "images/58_1_image.jpg";